import { Box, IconButton, Stack, type SxProps, type Theme, Typography } from '@mui/material';
import { CopyToClipboardButton, DynamicIcon, Tooltip } from 'src/components';

const liveFieldSx: SxProps<Theme> = {
  flex: '1 1 16.25rem',
  minWidth: 0,
  height: '2rem',
  px: 1.5,
  borderRadius: 1,
  border: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerLowest,
};

const statusDotSx = (live: boolean): SxProps<Theme> => ({
  width: '0.375rem',
  height: '0.375rem',
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: (theme) =>
    live ? theme.palette.success.main : theme.palette.text.disabled,
});

// Wraps above the actions once the pane is too narrow to show the address beside them.
export const LiveLink = ({ url }: { url?: string }) => (
  <Stack direction="row" alignItems="center" gap={1} sx={liveFieldSx}>
    <Box sx={statusDotSx(Boolean(url))} />
    <Typography variant="caption" fontWeight={600} color="text.secondary" flexShrink={0}>
      {url ? 'Live' : 'Not live'}
    </Typography>
    <Typography
      variant="body2"
      color={url ? 'text.primary' : 'text.secondary'}
      noWrap
      flex={1}
      minWidth={0}
    >
      {url ? url.replace(/^https?:\/\//, '') : 'Save the page to publish it'}
    </Typography>
    {url ? (
      <Stack direction="row" alignItems="center" gap={1} flexShrink={0}>
        <CopyToClipboardButton
          content={url}
          tooltipText="Copy live page link"
          successMessage="Live page link copied"
        />
        <Tooltip title="Open live page">
          <IconButton
            size="small"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open live page"
            sx={{ p: 0 }}
          >
            <DynamicIcon name="open_in_new" sx={{ fontSize: '1rem' }} />
          </IconButton>
        </Tooltip>
      </Stack>
    ) : null}
  </Stack>
);
